/*
Product Form
*/

class ProductForm extends HTMLElement {
  constructor() {
    super();
    this.flavor = "Mint";
    this.cadence = "Once";
    this.variantInput = null;
    this.planInput = null;
  }

  connectedCallback() {
    const variants = document.getElementById("product-variants");

    if (variants) {
      
      const variantsJson =
        document.getElementById("product-variants").innerText;

      this.variants = JSON.parse(variantsJson);

      // console.log("variantsJson", variantsJson); 
      
      this.variantId = this.variants[0].variantId;
      //console.log('InitialVariantIdCitrus-------->',this.variantId);
      this.planId = this.variants[0].planId;
      this.planInput = this.querySelector('input[name="selling_plan"]');
      this.variantInput = this.querySelector('input[name="id"]');
      //console.log('InitialVariantInput-------->',this.variantInput);
    }
  }

  setPlan(planId) {
    this.planId = planId;
    if (this.planInput) this.planInput.value = planId;
  }

  setPrice(price) {
    const atcPrice = this.querySelector(".atc-price");
    if (!atcPrice) return;
    const finalPrice = this.fmtPrice(price);
    atcPrice.innerText = finalPrice;
    // On the redesigned PDP the visible ATC label is synced from the selected pack.
    // Keep the hidden field accurate here, and refresh the visible price when present.
    if (document.querySelector(".re-pdp") && !document.querySelector(".re-pdp.is-onetime")) {
      const visiblePrice = this.querySelector(".atc_btn") || document.querySelector(".re-pdp .atc_btn");
      if (visiblePrice) visiblePrice.textContent = finalPrice;
    }
  }

  fmtPrice(price) {
    const variantPrice = price / 100;
    const formatter = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: Shopify.currency.active,
    });
    return formatter.format(variantPrice).replace(/\.00$/, "");
  }

  setVariant(variantId) {
    this.variantId = variantId;
    if (this.variantInput) this.variantInput.value = variantId;
  }
}

customElements.define("product-form", ProductForm);

/*
Flavor Selector
*/

class FlavorSelector extends HTMLElement {
  connectedCallback() {
    this.addEventListener("click", (e) => {
      const button = e.target?.closest("button");
      if (!button) return;
      const flavor = button.dataset.flavor || null;
      if (!flavor) return;

      this.updateButtonStyles(button);
      this.updateFlavorElements(flavor);
      this.updateWholesale(flavor);
      this.activateSelected(flavor);
    });
  }

  updateWholesale(flavor) {
    const form = this.closest("product-form");
    if (!form) return;

    form.querySelectorAll("[data-wholesale-flavor]").forEach((el) => {
      el.classList.add("hidden");
    });
    const match = form.querySelector(`[data-wholesale-flavor="${flavor}"]`);
    if (match) {
      match.classList.remove("hidden");
    }
  }

  updateButtonStyles(activeButton) {
    this.querySelectorAll("button").forEach((button) => {
      button.classList.remove("active");
      // Clear stale inline styles so CSS .active rules apply
      button.style.background = "";
      button.style.borderColor = "";
    });
    activeButton?.classList.add("active");
  }

  updateFlavorElements(flavor) {
    // Fixed previously-broken selectors (missing closing `]`) that threw and
    // prevented updateWholesale() from running — Mint click left Citrus ATC visible.
    // Variety has no dedicated [data-swap-flavor="Variety"] image (main-product.liquid
    // banners + video-info.liquid only render Citrus/Mint swap targets), so fall back
    // to Citrus — matches the convention used in main-product.liquid setActiveFlavorImages
    // (`refineVariety = flavor === "Variety" ? "Citrus" : flavor`).
    const hasVarietyGallery = !!document.querySelector('[data-swap-flavor="Variety"]');
    const targetFlavor = flavor === "Variety" && !hasVarietyGallery ? "Citrus" : flavor;
    document.querySelectorAll("[data-swap-flavor]").forEach((el) => {
      const isActive = el.getAttribute("data-swap-flavor") === targetFlavor;
      el.classList.toggle("opacity-0", !isActive);
      el.classList.toggle("!opacity-100", isActive);
      el.classList.toggle("z-10", isActive);
      if (el.closest(".re-pdp")) {
        el.classList.toggle("relative", isActive);
        el.classList.toggle("absolute", !isActive);
        el.classList.toggle("top-0", !isActive);
        el.classList.toggle("left-0", !isActive);
        el.classList.toggle("w-full", !isActive);
      }
    });
  }

  activateSelected(flavor) {
    const form = this.closest("product-form");
    if (!form) return;

    form.flavor = flavor;

    // Wholesale PDP has no cadence/variant JSON — skip retail subscription logic
    const isWholesaleForm = !!form.querySelector("[data-wholesale-flavor]");
    if (isWholesaleForm || !Array.isArray(form.variants)) return;

    const cadence = form.cadence;

    form.querySelectorAll("div[data-cadence]").forEach((panel) => {
      panel.classList.add("hidden");
    });
    form
      .querySelectorAll(
        `div[data-cadence="${cadence}"][data-flavor="${flavor}"]`
      )
      .forEach((panel) => {
        panel.classList.remove("hidden");

        const active = panel.querySelector("button.active");
        if (!active || !active.dataset.variantId) return;

        const variantId = active.dataset.variantId;
        const variantMatch = form.variants.find(
          (variant) => Number(variant.variantId) === Number(variantId)
        );

        if (variantMatch) {
          form.setVariant(variantMatch.variantId);

          if (
            variantMatch.sellingPlans.length > 0 &&
            form.cadence == "Subscribe"
          ) {
            const select = panel.querySelector("select");
            const selectedPlan = select?.value;

            const activePlan = variantMatch.sellingPlans.find(
              (plan) => plan.name === selectedPlan
            );

            if (activePlan) {
              form.setPrice(activePlan.price);
              form.setPlan(activePlan.id);
            }
          } else {
            form.setPrice(variantMatch.variantPrice);
            form.setPlan("");
          }
        }
      });
  }
}

customElements.define("flavor-selector", FlavorSelector);

/*
Variant Selector
*/

class VariantSelector extends HTMLElement {
  connectedCallback() {
    this.addEventListener("click", (e) => {
      const button = e.target?.closest("button.variant-price-btn, button[data-variant-id]");
      if (!button) return;

      this.updateButtonStyles(button);
      this.updateProductForm(button);
      this.setupSelectListener();
    });
  }

  setupSelectListener() {
    this.querySelectorAll("select").forEach((select) => {
      select.addEventListener("change", (e) => {
        const form = e.target?.closest("product-form");
        const variantButton = e.target?.closest("button");
        const variantId = variantButton?.dataset?.variantId;
        if (!form || !variantId) return;
        const planName = e.target.value;
        
        
        const variantMatch = form.variants.find(
          (variant) => Number(variant.variantId) === Number(variantId)
        );

        if (variantMatch) {
          const planMatch = variantMatch.sellingPlans.find(
            (plan) => plan.name === planName
          );
          form.setPlan(planMatch.id);
        }
      });
    });
  }

  updateProductForm(button) {
    const form = button.closest("product-form");
    const variantId = button.dataset.variantId;

    form.setVariant(variantId);

    const variantMatch = form.variants.find(
      (variant) => Number(variant.variantId) === Number(variantId)
    );

    if (variantMatch) {
      if (variantMatch.sellingPlans.length > 0 && form.cadence == "Subscribe") {
        const select = button.querySelector("select");
        const selectedPlan = select.value;
        const activePlan = variantMatch.sellingPlans.find(
          (plan) => plan.name === selectedPlan
        );

        if (activePlan) {
          form.setPrice(activePlan.price);
          form.setPlan(activePlan.id);
        }
      } else {
        form.setPrice(variantMatch.variantPrice);
        form.setPlan("");
      }
    }
  }

  updateButtonStyles(activeButton) {
    this.querySelectorAll("button").forEach((button) => {
      button.classList.remove("active");
    });
    activeButton?.classList.add("active");
  }
}

customElements.define("variant-selector", VariantSelector);

/*
Cadence Selector
*/

class CadenceSelector extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener("click", (e) => {
      const trigger = e.target?.closest("[data-cadence]");
      const cadence = trigger?.dataset?.cadence;
      if (!cadence) return;

      const button = trigger.matches("button") ? trigger : this.querySelector(`button[data-cadence="${cadence}"]`);
      this.updateButtonStyles(button);
      this.activateSelected(cadence);
    });
  }

  updateButtonStyles(button) {
    this.querySelectorAll("button").forEach((btn) => {
      btn.classList.remove("active");
    });
    button?.classList.add("active");
  }

  activateSelected(cadence) {
    const form = this.closest("product-form");
    //console.log(form)

    let flavor = form?.flavor;
    if (!flavor || !document.querySelector(".re-pdp")) {
      let currentUrlCheck = window.location.pathname.split('/');

      let urlAfter2 = new URL(window.location.href);
      let searchParamsInitial2 = urlAfter2.search
      let SearchFlavorInitial2 = searchParamsInitial2.includes('flavor=Mint') ? 'Mint' : 'Citrus';

      let CurrentLastPartCheck = currentUrlCheck[currentUrlCheck.length - 1];

      if(CurrentLastPartCheck == "Mint" || CurrentLastPartCheck == "mint" || SearchFlavorInitial2 == "Mint" || SearchFlavorInitial2 == "mint"){
        flavor = 'Mint';
      }else if(CurrentLastPartCheck == "Citrus" || CurrentLastPartCheck == "citrus" || SearchFlavorInitial2 == "Citrus" || SearchFlavorInitial2 == "citrus"){
        flavor = 'Citrus';
      }else{
        flavor = flavor || 'Citrus';
      }
    }

    form.cadence = cadence;

    form.querySelectorAll("div[data-cadence]").forEach((cadence) => {
      cadence.classList.add("hidden");
    });
    const cadenceMatches = form
      .querySelectorAll(
        `div[data-cadence="${cadence}"][data-flavor="${flavor}"]`
      )
      .forEach((cadence) => {
        cadence.classList.remove("hidden");

        const active = cadence.querySelector("button.active");
        const variantId = active ? active.dataset.variantId : null;
        const variantMatch = form.variants.find(
          (variant) => Number(variant.variantId) === Number(variantId)
        );

        if (variantMatch) {
         // console.log(variantMatch.variantId);
          form.setVariant(variantMatch.variantId);

          if (
            variantMatch.sellingPlans.length > 0 &&
            form.cadence == "Subscribe"
          ) {
            const select = cadence.querySelector("select");
            const selectedPlan = select.value;
            const activePlan = variantMatch.sellingPlans.find(
              (plan) => plan.name === selectedPlan
            );

            if (activePlan) {
              form.setPrice(activePlan.price);
              form.setPlan(activePlan.id);
            }
          } else {
            form.setPrice(variantMatch.variantPrice);
            form.setPlan("");
          }
        }
      });
  }
}

customElements.define("cadence-selector", CadenceSelector);

/*
Quantity Selector
*/

class QuantitySelector extends HTMLElement {
  constructor() {
    super();
    this.quantity = 1;
  }

  connectedCallback() {
    const quantityContainer = this.closest(
      "[data-wholesale-flavor], [data-fp-wholesale-flavor]"
    );

    this.input = quantityContainer?.querySelector('cart-add [name="quantity"]');
    this.currQuantity = this.querySelector(".curr-quantity");

    if (!this.input || !this.currQuantity) return;

    this.quantity = Number.parseInt(this.input.value, 10) || 1;
    this.addEventListener("click", (e) => {
      this.handleClick(e);
    });
  }

  setQuantity(qty) {
    const next = Math.max(1, Number.parseInt(qty, 10) || 1);
    this.quantity = next;
    if (this.input) this.input.value = next;
    if (this.currQuantity) this.currQuantity.innerText = next;
  }

  handleClick(e) {
    e.preventDefault();
    const button = e.target?.closest("button");

    if (button) {
      if (button.name === "increment") {
        this.quantity = this.quantity + 1;
      } else if (this.quantity > 1) {
        this.quantity = this.quantity - 1;
      }

      // Keep qty isolated per flavor panel (Citrus / Mint / Variety) and per size
      this.setQuantity(this.quantity);
    }
  }
}

customElements.define("quantity-selector", QuantitySelector);

// Wait for DOM to be fully loaded
document.addEventListener('DOMContentLoaded', function() {
  // Get the selling plan input
  const sellingPlanInputs = document.querySelectorAll('input[name="selling_plan"]');
  // Get the price display element in the Add to Cart button
  const atcPriceElement = document.querySelector('.atc-price');
  const citrusOncePanel = document.querySelector('variant-selector div[data-flavor="Citrus"][data-cadence="Once"]');
  const minOncePanel = document.querySelector('variant-selector div[data-flavor="Mint"][data-cadence="Once"]');

  const activeButton = citrusOncePanel?.querySelector('button.active');

  const compareAtPriceElement = activeButton?.querySelector('.new-pr');

  
  // Store the original price from the Once option

  let originalPrice = '';
  if (atcPriceElement) {
    atcPriceElement.innerText = compareAtPriceElement?.innerText;
    originalPrice = atcPriceElement.innerText;
  }
  
  sellingPlanInputs.forEach(input => {
    const originalValue = input.value;
    input.value = '';
  });
  
});
